import{css as i}from"lit";var t=i`:host{--internal-label-min-width:initial;display:block;width:100%}.private-host{width:100%}`;export default t;
